/**
 * Pin della barra recap preventivo.
 * AdminLTE body.fixed + .wrapper { overflow: hidden } annulla position:sticky:
 * la barra va in position:fixed sotto .main-header, allineata al sentinel in-flow.
 */
export const STICKY_PIN_GAP = 8;

export function computeStickyPinState({
    headerBottom = 0,
    sentinelTop = 0,
    sentinelLeft = 0,
    sentinelWidth = 0,
    stackHeight = 0,
    gap = STICKY_PIN_GAP,
} = {}) {
    const pinTop = Number(headerBottom) + Number(gap);
    if (sentinelTop > pinTop) {
        return {
            pinned: false,
            height: 0,
            style: {},
        };
    }

    return {
        pinned: true,
        height: stackHeight,
        style: {
            top: `${pinTop}px`,
            left: `${Math.round(sentinelLeft)}px`,
            width: `${Math.round(sentinelWidth)}px`,
        },
    };
}
